module.exports = __webpack_public_path__ + "img/app-ico-light-blue-01.f7dce977.svg";